import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { fromEvent } from 'rxjs';
import { throttleTime, share } from 'rxjs/operators';

import AlertStructuresInDescription from './AlertStructuresInDescription';
import AlertToggleButton from './AlertToggleButton';

import './AlertDescription.scss';

const resize$ = fromEvent(window, 'resize').pipe(throttleTime(300), share());

function AlertDescription(props) {
  const { description, showLabel, hideLabel } = props;
  const [open, setOpen] = useState(false);
  const [showToggleButton, setShowToggleButton] = useState(false);
  const descriptionRef = useRef(null);

  const toggle = useCallback(() => {
    setOpen((prevOpen) => !prevOpen);
  }, []);

  const calcToggleButton = useCallback(() => {
    if (descriptionRef.current && open === false) {
      const shouldShowToggleButton = descriptionRef.current.scrollWidth > descriptionRef.current.offsetWidth;
      setShowToggleButton(shouldShowToggleButton);
    }
  }, [open]);

  useEffect(() => {
    calcToggleButton();
    const resizeStream$ = resize$.subscribe(calcToggleButton);
    return () => {
      resizeStream$.unsubscribe();
    };
  }, [calcToggleButton]);

  return (
    <section
      className={classnames('alert-description alerts--second-line clearfix', {
        'alert-description--collapsed': !open,
        'alert-description--padding-for-toggle': !open && showToggleButton,
      })}>
      <div className="alert-description--content-wrapper">
        <p ref={descriptionRef} className="alert-description--text">
          {description}
        </p>
        <AlertStructuresInDescription {...props} />
        {showToggleButton && <AlertToggleButton open={open} toggle={toggle} showLabel={showLabel} hideLabel={hideLabel} />}
      </div>
    </section>
  );
}

AlertDescription.propTypes = {
  description: PropTypes.string,
  showLabel: PropTypes.string.isRequired,
  hideLabel: PropTypes.string.isRequired,
};

export default AlertDescription;
